import { DataBean } from "../DataBean";

export class WorkActivityPriority extends DataBean {

  public async getWorkActivityPriorityCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getWorkActivityPriorityCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteWorkActivityPriority(idworkactivitypriority: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteWorkActivityPriority_Number",
      [idworkactivitypriority]
    );
  }

  public async updateWorkActivityPriority(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivityPriority_updateWorkActivityPriority_com.advantage.processflow.bean.WorkActivityPriority",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.WorkActivityPriority",
        },
      ]
    );
  }
}
